import React from "react";
import { Col, Container, Row, Image, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IMAGES } from "../../images/images";
import {
  StackedCarousel,
  ResponsiveContainer,
} from "react-stacked-center-carousel";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

export const data = [
  {
    cover: IMAGES.AppImg1,
    title: "Interstaller",
  },
  {
    cover: IMAGES.AppImg2,
    title: "Inception",
  },
  {
    cover: IMAGES.AppImg3,
    title: "Blade Runner 2049",
  },
  {
    cover: IMAGES.AppImg5,
    title: "Icon man 3",
  },
  {
    cover: IMAGES.AppImg4,
    title: "Venom",
  },
];

export const SliderCard = React.memo(function (props) {
  const { data, dataIndex } = props;
  const { cover } = data[dataIndex];
  return (
    <div
      style={{
        backgroundImage: "url(" + IMAGES.PhonePlaceholder + ")",
      }}
      className="placeholderCss"
    >
      <img
        style={{
          objectFit: "cover",
        }}
        alt=""
        draggable={false}
        src={cover}
      />
    </div>
  );
});

const HomeScreen = () => {
  const ref = React.useRef();
  const handleAppOpen = () => {
    const url =
      "https://apps.apple.com/in/app/chummy-find-real-friends/id6738577443";
    window.open(url, "_blank");
  };
  return (
    <React.Fragment>
      <section className="bannersection bannersection1 ban">
        <Container fluid>
          <Row>
            <Col md={12} lg={12} xl={12} xxl={5}>
              <div className="bannersection__content">
                <h3>
                  Interact meaningfully <Image src={IMAGES.Logo} alt="" />
                </h3>
                <h1>Welcome to Chummy Friend Finder App</h1>
                <h4>Tired of Spending the Weekend Alone? We’ll fix that.</h4>
                <p>Find your people. Find your pack</p>
                <Link className="btn btn-primary" onClick={handleAppOpen}>
                  Get Started{" "}
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="bannerimg"></div>
      </section>

      <section className="sectionPadding">
        <Container fluid>
          <Row>
            <Col>
              <div
                className="subscribeform"
                style={{ backgroundImage: `url(${IMAGES.Subscribe})` }}
              >
                <h2>Subscribe today to get 15% Off</h2>
                <div className="formFlex">
                  <Form.Control type="text" placeholder="Name" />
                  <Form.Control type="text" placeholder="Email Address" />
                  <Button variant="primary">Pay $49.00</Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="sectionPadding feature" id="features">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="headerSection">
                <h3>Features</h3>
                <h2>Our Features</h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6} lg={4}>
              <div className="feature__body">
                <div className="feature__icon">
                  <Image src={IMAGES.Feature1} alt="" />
                </div>
                <h3>
                  Innovative Group <br /> Interaction
                </h3>
                <p>
                  "Chummy" stands out with its unique approach to social
                  networking by focusing on group interactions rather than
                  one-on-one connections. Unlike other apps, we bring users
                  together in small, carefully curated groups, fostering a sense
                  of community and shared experience. This feature allows for
                  more dynamic conversations and the opportunity to form
                  multiple meaningful connections simultaneously
                </p>
              </div>
            </Col>
            <Col md={6} lg={4}>
              <div className="feature__body">
                <div className="feature__icon">
                  <Image src={IMAGES.Feature2} alt="" />
                </div>
                <h3>
                  Sophisticated <br /> Matchmaking Algorithm
                </h3>
                <p>
                  Our app goes beyond superficial criteria, utilizing a
                  sophisticated matchmaking algorithm that considers
                  personality, values, humor, and interests. This method ensures
                  a deeper compatibility between users, leading to more
                  meaningful and lasting connections. The emphasis on
                  personality and values over just physical appearance sets
                  "Chummy" apart, providing a more authentic and holistic
                  approach to meeting new people.
                </p>
              </div>
            </Col>
            <Col md={6} lg={4}>
              <div className="feature__body">
                <div className="feature__icon">
                  <Image src={IMAGES.Feature3} alt="" />
                </div>
                <h3>
                  Structured Conversations <br /> with Ice Breakers
                </h3>
                <p>
                  To ease initial interactions and keep conversations flowing,
                  "Chummy" incorporates structured conversation starters and ice
                  breakers. These features help eliminate the awkwardness of
                  starting a chat with someone new, encouraging open and
                  engaging discussions right from the start. By providing these
                  prompts, we ensure that conversations are lively, enjoyable,
                  and conducive to building strong friendships.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="sectionPadding sectionPaddingNone screenshot">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="screenshotflex">
                <div className="headerSection">
                  <h3>ScreenShot</h3>
                  <h2>Checkout Our App Interface Look</h2>
                </div>
                <div className="sliderBtns">
                  <Button
                    className="twitch-button left"
                    size="small"
                    onClick={() => ref.current?.goBack()}
                  >
                    <MdKeyboardArrowLeft />
                  </Button>
                  <Button
                    className="twitch-button right"
                    size="small"
                    onClick={() => ref.current?.goNext()}
                  >
                    <MdKeyboardArrowRight />
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <div className="sliderCenter">
                <ResponsiveContainer
                  carouselRef={ref}
                  render={(parentWidth, carouselRef) => {
                    let currentVisibleSlide = 5;
                    if (parentWidth <= 1400) currentVisibleSlide = 5;
                    if (parentWidth <= 1024) currentVisibleSlide = 5;
                    if (parentWidth <= 991) currentVisibleSlide = 1;
                    return (
                      <StackedCarousel
                        ref={carouselRef}
                        slideComponent={SliderCard}
                        slideWidth={parentWidth < 800 ? parentWidth - 20 : 350}
                        carouselWidth={parentWidth}
                        data={data}
                        currentVisibleSlide={currentVisibleSlide}
                        maxVisibleSlide={5}
                        useGrabCursor
                      />
                    );
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="sectionPadding aboutUs" id="about">
        <Image src={IMAGES.AboutUs} alt="" />
        <div className="aboutUs__body">
          <h3>ABOUT US</h3>
          <h2>
            Interact with your <br /> matches.
          </h2>
          <p>
            We believe the most important thing in life are relationships with
            others. And not just any relationships, but relationships that are
            genuine. However more people report feeling lonelier then ever, and
            a life without relationships is a difficult one. We’re here to
            change that. Our mission is to end loneliness and help everyone find
            their group of friends and a community of people in which they feel
            appreciated and wanted around
          </p>
        </div>
      </section>

      <section className="sectionPadding sectionPaddingNone howitworks">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="headerSection">
                <h2>How it works</h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={4} md={6} className="mb-lg-0 mb-4">
              <div className="howitworks__body">
                <div className="howitworks__icon">
                  <Image src={IMAGES.HowItWorksIcon1} alt="" />
                  <Image src={IMAGES.Shape} className="shape" alt="" />
                </div>
                <h3>Create your Profile</h3>
                <p>
                  Make your Biography and Take our unique personality test so we
                  can match you with people who share your interests, values,
                  passions, and vision for life
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-lg-0 mb-4">
              <div className="howitworks__body">
                <div className="howitworks__icon">
                  <Image src={IMAGES.HowItWorksIcon2} alt="" />
                  <Image src={IMAGES.Shape} className="shape" alt="" />
                </div>
                <h3>Interact with matches</h3>
                <p>
                  We match you with people just like you and you Interact with
                  them in a timed setting of 50 hours. They say it takes 50
                  hours to go from strangers to friends. But who has time for
                  that in the real world? We make it fun and quick. While also
                  limiting you to 5 groups at a time so you focus on the people
                  in your group
                </p>
              </div>
            </Col>
            <Col lg={4} md={6} className="mb-lg-0 mb-4">
              <div className="howitworks__body">
                <div className="howitworks__icon">
                  <Image src={IMAGES.HowItWorksIcon3} alt="" />
                  <Image src={IMAGES.Shape} className="shape" alt="" />
                </div>
                <h3>Meet with person</h3>
                <p>
                  Get off the app! We will give you ice breakers for you guys to
                  discuss to get to know each other, if you feel you want to
                  meet them at the end of the 50 hours we will help get you to
                  meet each other in real life so you can finally meet your
                  future best friends
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="sectionPadding downloadapp" id="app">
        <Container>
          <Row className="align-items-center">
            <Col md={6} lg={6}>
              <div className="downloadapp__body">
                <h3>DOWNLOAD APP</h3>
                <h2>Download Our mobile App</h2>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et
                </p>
                <div className="googleBtn">
                  <Link>
                    <Image src={IMAGES.GoogleImg} alt="" />
                  </Link>
                  <Link onClick={handleAppOpen}>
                    <Image src={IMAGES.AppleImg} alt="" />
                  </Link>
                </div>
              </div>
            </Col>
            <Col md={6} lg={6}>
              <Image src={IMAGES.DownloadImg} className="download" alt="" />
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default HomeScreen;
